import dayjs from 'dayjs'
import { useI18n } from 'vue-i18n'

export function imageUrlWithFixedWidth(imgUrl: string = '', targetWidth: number): string {
  return replaceImage(imgUrl, targetWidth + 'x')
}

export function calcImageScaleWithSize(
  imgUrl: string = '',
  srcWidth: number = -1,
  srcHeight: number = -1,
  targetWidth: number = 200,
  targetHeight: number = 200
): string {
  return imageUrlWithFixedWidth(imgUrl, targetWidth)
}

function replaceImage(imgUrl: string, scaleCmd: string): string {
  if (imgUrl == null || imgUrl.length === 0) return imgUrl
  const index = imgUrl.lastIndexOf('webp')
  if (index < 0) {
    return imgUrl
  }
  const urlParts = imgUrl.substring(0, index)
  return urlParts + 'webp/thumbnail/' + scaleCmd
}

export function replaceImageScale(imgUrl: string, newScale: number): string {
  if (imgUrl == null || imgUrl.length === 0) return imgUrl
  const index = imgUrl.lastIndexOf('webp')
  const urlParts = imgUrl.substring(0, index)
  return urlParts + 'webp/thumbnail/!' + newScale + 'p'
}

export const getTimeObj = (time: string | number) => {
  const format = 'YYYY-MM-DD HH:mm:ss'
  if (typeof time === 'string' && time.length === format.length) {
    return dayjs(time, format)
  } else if (typeof time === 'number') {
    return dayjs(time)
  } else {
    console.error('----> wrong format time, return current time', time)
    return dayjs()
  }
}

export const timeBefore = (time: string | number) => {
  const timeObj = getTimeObj(time)
  return timeObj.isBefore(dayjs())
}

export const timeAfter = (time: string | number) => {
  const timeObj = getTimeObj(time)
  return timeObj.isAfter(dayjs())
}

// 时间范围判断
export const timeInRange = (start: string | number, end: string | number) => {
  const startObj = getTimeObj(start)
  const endObj = getTimeObj(end)
  const curr = dayjs()
  return curr.isAfter(startObj) && curr.isBefore(endObj)
}

export const formatNumber = (number: number) => {
  if (!number) return 0
  if (number < 10000) {
    return number.toString()
  } else if (number < 100000000) {
    const result = Math.floor(number / 100) / 100
    return result + '万'
  } else {
    const result = Math.floor(number / 1000000) / 100
    return result + '亿'
  }
}

// 高度
export const screenHeight = window.screen.height
// 宽度
export const screenWidth = window.screen.width

type ThrottleFunction = (...args: any[]) => void

export const throttle = (func: ThrottleFunction, wait: number): ThrottleFunction => {
  let isThrottled = false
  let lastArgs: any[] | null = null
  let lastThis: any

  function wrapper(this: any, ...args: any[]) {
    if (isThrottled) {
      lastArgs = args
      lastThis = this
      return
    }

    func.apply(this, args)

    isThrottled = true

    setTimeout(() => {
      isThrottled = false

      if (lastArgs) {
        wrapper.apply(lastThis, lastArgs)
        lastArgs = lastThis = null
      }
    }, wait)
  }

  return wrapper
}

export const getQueryString = (name: string) => {
  const reg = new RegExp('[&, ?]' + name + '=([^\\&,\\#]*)', 'i')
  const value = reg.exec(window.location.href)
  return value ? value[1] : ''
}

let h5Env = ''

if (/micromessenger/i.test(navigator.userAgent)) {
  h5Env = 'wechat'
} else {
  h5Env = 'browser'
}

export const isH5InWechat = h5Env === 'wechat'

export const isWeChatPayEnv = /micromessenger/i.test(navigator.userAgent);

// localStorage
export const getStorage = (key: string) => {
  let value = window.localStorage.getItem(key) || ''
  try {
    // 对象的话 返回对象 其他的不管  如果是 '11' 数字字符串的话 会变成 数字 11
    let jsonVal = JSON.parse(value)
    if (typeof jsonVal === 'object') {
      return jsonVal
    } else {
      return value
    }
  } catch (err) { }
  return value
}
export const setStorage = (key: string, value: any) => {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.localStorage.setItem(key, value)
}
export const removeStorage = (key: string) => {
  window.localStorage.removeItem(key)
}
export const debounce = <F extends (...args: any[]) => any>(
  func: F,
  delay: number
): ((...args: Parameters<F>) => void) => {
  let timer: ReturnType<typeof setTimeout>

  return function (this: any, ...args: Parameters<F>) {
    clearTimeout(timer)
    const context = this

    timer = setTimeout(() => {
      func.apply(context, args)
    }, delay)
  }
}

export const VideoTypes = ['wmv', 'mp4', 'avi', 'mov', 'm3u8']

export const isTypeVideo = (type: string) => {
  return ['wmv', 'mp4', 'avi', 'mov'].indexOf(type) > -1
}

export const isMediaType = (fileName: string) => {
  for (const value of VideoTypes) {
    if (fileName.toLowerCase().endsWith(value)) {
      return true
    }
  }
  return false
}

export function getSession(key: string) {
  let value = window.sessionStorage.getItem(key)
  try {
    // 对象的话 返回对象 其他的不管  如果是 '11' 数字字符串的话 会变成 数字 11
    let jsonVal = JSON.parse(value as string)
    if (typeof jsonVal === 'object') {
      return jsonVal
    } else {
      return value
    }
  } catch (err) { }
  return value
}
export function setSession(key: string, value: Object) {
  if (typeof value === 'object') {
    value = JSON.stringify(value)
  }
  window.sessionStorage.setItem(key, value as string)
}
export function removeSession(key: string) {
  window.sessionStorage.removeItem(key)
}

export function toW(num: number) {
  if (num == null) return ''
  if (num >= 10000) {
    return (num / 10000).toFixed(1) + 'w'
  } else {
    return num.toString()
  }
}

export function toHour(num: number, type = 'H') {
  return type === 'H' ? Number((num / (1000 * 60 * 60)).toFixed(2)) : Number((num / (1000 * 60)).toFixed(2))
}

export function convertMillisecondsToHMS(milliseconds: any) {
  // 计算总共有多少秒
  let totalSeconds = Math.floor(milliseconds / 1000)

  // 计算有多少小时
  let hours = Math.floor(totalSeconds / 3600)

  // 剩余的秒数
  let secondsLeft = totalSeconds % 3600

  // 计算分钟数
  let minutes = Math.floor(secondsLeft / 60)

  // 剩余的秒数
  let seconds = secondsLeft % 60

  // 组合时分秒
  return [hours, minutes, seconds]
}

export function toNewLine(test: string) {
  // 将n替换为br
  if (test) {
    return test.replace(/\n/g, '<br/>')
  } else {
    return test
  }
}

/**
 * 将毫秒转换为小时,保留一位小数
 * @param ms 毫秒数
 * @returns 转换后的小时数,保留一位小数
 */
export function msToHours(ms: number): string {
  const hours = ms / (1000 * 60 * 60)
  return hours.toFixed(1)
}

export function getSourceLabel(sourceType: number) {
  console.log('sourceType', sourceType)
  const { t } = useI18n()
  switch (sourceType) {
    // case 100:
    //   return t('pc_community_from') + t('app_task_exam');
    case 101:
      return t('pc_community_from') + t('app_my_training')
    case 102:
      return t('pc_community_from') + t('app_face_to_teaching')
    case 103:
      return t('pc_community_from') + t('app_course')
    default:
      return ''
  }
}

export function getSourceLabelStudent(sourceType: number) {
  const { t } = useI18n()
  switch (sourceType) {
    case 100:
      return t('pc_community_from') + t('app_task_exam')
    case 101:
      return t('pc_community_from') + t('app_my_training')
    case 102:
      return t('pc_community_from') + t('app_face_to_teaching')
    case 103:
      return t('pc_community_from') + t('course_exam')
    default:
      return ''
  }
}

export function getIsQualified(Type: number) {
  // 是否合格: 0-否 1-是
  const { t } = useI18n()
  switch (Type) {
    case 0:
      return t('app_unqualified')
    case 1:
      return t('app_qualified')
    default:
      return ''
  }
}

export function formatToPrice(number: number | string, type?: string) {
  if (type === 'Rp') {
    return formatToRupiah(number)
  } else {
    return number
  }
}

function formatToRupiah(number: number | string) {
  // 将数字转换为字符串，并使用正则表达式添加句点作为千位分隔符
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}

export const ensureHttps = (url: string) => {
  if (!url) return url;
  const s = String(url).trim();
  if (s.startsWith("//")) return "https:" + s;
  return s.replace(/^http:\/\//i, "https://");
};